import React from 'react'
import { Button, ConnectorId, useWalletModal } from '@pancakeswap-libs/uikit'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import useI18n from 'hooks/useI18n'
import { connWallt } from 'utils/wallet'

const UnlockButton = (props) => {
  const TranslateString = useI18n()
  const { connect, reset,status } = useWallet()
  const { onPresentConnectModal } = useWalletModal((connectorId: ConnectorId)=>{connWallt(connectorId,connect,status)}, reset)

  return (
    <Button onClick={onPresentConnectModal} {...props}>
      {TranslateString(72,'Unlock Wallet')}
    </Button>
  )
}

export default UnlockButton
